// FETCH ALL GENERAL PO
export const FETCH_ACCESSORIES_PO_MASTER_REQUEST_DK = 'FETCH_ACCESSORIES_PO_MASTER_REQUEST_DK';
export const FETCH_ACCESSORIES_PO_MASTER_SUCCESS_DK = 'FETCH_ACCESSORIES_PO_MASTER_SUCCESS_DK';
export const FETCH_ACCESSORIES_PO_MASTER_FAILURE_DK = 'FETCH_ACCESSORIES_PO_MASTER_FAILURE_DK';

// CREATE GENERAL PO
export const CREATE_ACCESSORIES_PO_MASTER_REQUEST_DK = 'CREATE_ACCESSORIES_PO_MASTER_REQUEST_DK';
export const CREATE_ACCESSORIES_PO_MASTER_SUCCESS_DK = 'CREATE_ACCESSORIES_PO_MASTER_SUCCESS_DK';
export const CREATE_ACCESSORIES_PO_MASTER_FAILURE_DK = 'CREATE_ACCESSORIES_PO_MASTER_FAILURE_DK';

// UPDATE GENERAL PO
export const UPDATE_ACCESSORIES_PO_MASTER_REQUEST_DK = 'UPDATE_ACCESSORIES_PO_MASTER_REQUEST_DK';
export const UPDATE_ACCESSORIES_PO_MASTER_SUCCESS_DK = 'UPDATE_ACCESSORIES_PO_MASTER_SUCCESS_DK';
export const UPDATE_ACCESSORIES_PO_MASTER_FAILURE_DK = 'UPDATE_ACCESSORIES_PO_MASTER_FAILURE_DK';

// FETCH SINGLE STATE OF GENERAL PO
export const FETCH_SINGLE_ACCESSORIES_PO_MASTER_REQUEST_DK = 'FETCH_SINGLE_ACCESSORIES_PO_MASTER_REQUEST_DK';
export const FETCH_SINGLE_ACCESSORIES_PO_MASTER_SUCCESS_DK = 'FETCH_SINGLE_ACCESSORIES_PO_MASTER_SUCCESS_DK';
export const FETCH_SINGLE_ACCESSORIES_PO_MASTER_FAILURE_DK = 'FETCH_SINGLE_ACCESSORIES_PO_MASTER_FAILURE_DK';

// DELETE GENERAL PO
export const DELETE_ACCESSORIES_PO_MASTER_REQUEST_DK = 'DELETE_ACCESSORIES_PO_MASTER_REQUEST_DK';
export const DELETE_ACCESSORIES_PO_MASTER_SUCCESS_DK = 'DELETE_ACCESSORIES_PO_MASTER_SUCCESS_DK';
export const DELETE_ACCESSORIES_PO_MASTER_FAILURE_DK = 'DELETE_ACCESSORIES_PO_MASTER_FAILURE_DK';

// FETCH PROPERTY
export const FETCH_PROPERTY_DATA_FOR_ACCESSORIES_PO_MASTER_REQUEST_DK = 'FETCH_PROPERTY_DATA_FOR_ACCESSORIES_PO_MASTER_REQUEST_DK';
export const FETCH_PROPERTY_DATA_FOR_ACCESSORIES_PO_MASTER_SUCCESS_DK = 'FETCH_PROPERTY_DATA_FOR_ACCESSORIES_PO_MASTER_SUCCESS_DK';
export const FETCH_PROPERTY_DATA_FOR_ACCESSORIES_PO_MASTER_FAILURE_DK = 'FETCH_PROPERTY_DATA_FOR_ACCESSORIES_PO_MASTER_FAILURE_DK';

export const RESET_ACCESSORIES_PO_MASTER_INFO_DK = 'RESET_ACCESSORIES_PO_MASTER_INFO_DK';

export const CREATE_ACCESSORIES_PO_MASTER_FORM_DK = 'CREATE_ACCESSORIES_PO_MASTER_FORM_DK';

export const UPDATE_ACCESSORIES_PO_MASTER_FORM_DK = 'UPDATE_ACCESSORIES_PO_MASTER_FORM_DK';

// NAVIGATE TO PARTY DETAILS COMPONENT
export const NAVIGATE_ACCESSORIES_PO_DETAILS_DK = 'NAVIGATE_ACCESSORIES_PO_DETAILS_DK';

// NAVIGATE TO GENERAL PO COMPONENT
export const NAVIGATE_ACCESSORIES_PO_MASTER_DK = 'NAVIGATE_ACCESSORIES_PO_MASTER_DK';
export const ACCESSORIES_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK = 'ACCESSORIES_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK';
export const ACCESSORIES_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK = 'ACCESSORIES_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK';


// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_ACCESSORIES_PO_STYLE_REQUEST_DK = 'FETCH_ACCESSORIES_PO_STYLE_REQUEST_DK';
export const FETCH_ACCESSORIES_PO_STYLE_SUCCESS_DK = 'FETCH_ACCESSORIES_PO_STYLE_SUCCESS_DK';
export const FETCH_ACCESSORIES_PO_STYLE_FAILURE_DK = 'FETCH_ACCESSORIES_PO_STYLE_FAILURE_DK';



// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_ACCESSORIES_PO_INVOICE_REQUEST = 'FETCH_ACCESSORIES_PO_INVOICE_REQUEST';
export const FETCH_ACCESSORIES_PO_INVOICE_SUCCESS = 'FETCH_ACCESSORIES_PO_INVOICE_SUCCESS';
export const FETCH_ACCESSORIES_PO_INVOICE_FAILURE = 'FETCH_ACCESSORIES_PO_INVOICE_FAILURE';

export const RESET_ACCESSORIES_PO_INVOICE = 'RESET_ACCESSORIES_PO_INVOICE';


// FETCH ALL GENERAL PO DETAILS
export const FETCH_ACCESSORIES_PO_MASTER_WITHOUT_ID_REQUEST_DK = 'FETCH_ACCESSORIES_PO_MASTER_WITHOUT_ID_REQUEST_DK';
export const FETCH_ACCESSORIES_PO_MASTER_WITHOUT_ID_SUCCESS_DK = 'FETCH_ACCESSORIES_PO_MASTER_WITHOUT_ID_SUCCESS_DK';
export const FETCH_ACCESSORIES_PO_MASTER_WITHOUT_ID_FAILURE_DK = 'FETCH_ACCESSORIES_PO_MASTER_WITHOUT_ID_FAILURE_DK';
